import { render, staticRenderFns } from "./ExploreTitle.vue?vue&type=template&id=05944fd4&scoped=true"
import script from "./ExploreTitle.vue?vue&type=script&lang=js"
export * from "./ExploreTitle.vue?vue&type=script&lang=js"
import style0 from "./ExploreTitle.vue?vue&type=style&index=0&id=05944fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05944fd4",
  null
  
)

export default component.exports